/**
 * Brands directory — search filter and letter jump navigation.
 */
if (!customElements.get('brands-directory')) {
  class BrandsDirectory extends HTMLElement {
    connectedCallback() {
      this.searchInput = this.querySelector('[data-brands-search]');
      this.groups = Array.from(this.querySelectorAll('[data-brands-letter]'));
      this.items = Array.from(this.querySelectorAll('.brands__item'));
      this.noResults = this.querySelector('[data-brands-no-results]');
      this.jumpLinks = Array.from(this.querySelectorAll('[data-brands-jump]'));

      this.searchInput?.addEventListener('input', () => this.filter());
      this.jumpLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const letter = link.getAttribute('data-brands-jump');
          const target = this.querySelector(`[data-brands-letter="${letter}"]`);
          if (!target || target.hidden) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    filter() {
      const query = (this.searchInput?.value || '').trim().toLowerCase();

      this.items.forEach((item) => {
        const name = item.getAttribute('data-brand-name') || '';
        item.hidden = query !== '' && !name.includes(query);
      });

      let visibleCount = 0;
      this.groups.forEach((group) => {
        const hasVisible = Array.from(group.querySelectorAll('.brands__item')).some((item) => !item.hidden);
        group.hidden = !hasVisible;
        if (hasVisible) visibleCount += 1;
      });

      if (this.noResults) {
        this.noResults.hidden = visibleCount > 0 || this.items.length === 0;
      }

      this.jumpLinks.forEach((link) => {
        const letter = link.getAttribute('data-brands-jump');
        const target = this.querySelector(`[data-brands-letter="${letter}"]`);
        link.classList.toggle('brands__nav-link--disabled', !target || target.hidden);
        if (!target || target.hidden) {
          link.setAttribute('aria-disabled', 'true');
        } else {
          link.removeAttribute('aria-disabled');
        }
      });
    }
  }

  customElements.define('brands-directory', BrandsDirectory);
}
